import React from 'react';
import Columns, { Column } from '../../../shared/components/Columns';
import FAQs, { QuestionAnswerProps } from './FAQs';

interface ColumnFAQsProps {
    faqSections: QuestionAnswerProps[][];
    onOpen: (faq: QuestionAnswerProps) => void;
}

function FlexibleColumnFAQs({ faqSections, onOpen }: ColumnFAQsProps) {
    // NOTE - numColumns has to be a factor of 12 due to the grid columns
    const numColumns = faqSections.length;
    const columnSize = 12 / numColumns;

    return (
        <Columns>
            {faqSections.map((faqSection, index) => {
                // TODO - this is a bit tightly coupled
                const firstColumn = index !== numColumns - 1;

                return (
                    <Column key={faqSection[0].question} width={[12, 12, columnSize, columnSize]}>
                        <FAQs isFirstColumn={firstColumn} faqs={faqSection} onOpen={onOpen} />
                    </Column>
                );
            })}
        </Columns>
    );
}

export default FlexibleColumnFAQs;
